import Trans from "features/translation/components/Trans";
import PropTypes from 'prop-types';
import { useState } from "react";
import Dialog from "components/ui/Dialog/Dialog";
import { useDialog } from "context/DialogContext";
import Button from "components/ui/Button/Button";
import useData from "hooks/useData";

const ConversationDelete = ({ senderId, name, messageCount, onCompleted }) => {
  const { hideDialog } = useDialog();
  const { deleteData } = useData();
  const [ loading, setLoading ] = useState(false);
  const [ error, setError ] = useState();

  const onExecute = async () => {
    setError();
    setLoading(true);

    const result = await deleteData(`rest/conversation/${ senderId }`);

    if (result?.status === 204) {
      if (onCompleted) {
        onCompleted(senderId);
      }
      hideDialog();
    } else {
      setError(`Het gesprek kon niet worden verwijderd (${ result?.status })`);
    }

    setLoading(false);
  };

  return (
    <Dialog title={ 'Gesprek verwijderen' }
            loading={ loading }
            errorMessage={ error }>
      <div className={ `dialog__row` }>
        <h3>Weet u zeker dat u het gesprek met { name } wilt verwijderen?</h3>
        {
          messageCount > 1 &&
          <div>{ messageCount } berichten zullen worden verwijderd.</div>
        }
        <div className={"text-small italic"}>
          <Trans text={"Het gesprek wordt alleen uit uw eigen berichtenbox verwijderd, bij uw gesprekspartner blijft het gesprek in de berichtenbox staan."} />
        </div>
      </div>
      <div className="dialog__buttons dialog__buttons">
        <Button onClick={ () => hideDialog() }>Annuleren</Button>
        <Button onClick={ onExecute } variant="secondary">Verwijderen</Button>
      </div>
    </Dialog>
  )
}

ConversationDelete.propTypes = {
  senderId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  messageCount: PropTypes.number.isRequired,
  onCompleted: PropTypes.func
}

export default ConversationDelete;
